import { Dayjs } from "dayjs";
import { IPatchRequest } from "../../api/common/patch";

export const buildNHCDateTimePatch = (
    oldDate: string | null,
    oldTime: string | null,
    v: Dayjs | null
  ): IPatchRequest => {
    const dateValue = v ? v.format("YYYY-MM-DD") : null;
    const timeValue = v ? v.format("HH:mm:ss") : null;
  
    return {
      patches: [
        ...(oldDate !== dateValue
          ? [
              {
                op: "set",
                property: "/NHCDate",
                from: oldDate ?? null,
                to: dateValue,
              },
            ]
          : []),
        ...(oldTime !== timeValue
          ? [
              {
                op: "set",
                property: "/NHCTime",
                from: oldTime ?? null,
                to: timeValue,
              },
            ]
          : []),
      ],
    };
  };